import React, { useEffect, useRef, useState } from 'react';
import {
  mergeFieldLayout,
  normalizeTopicCfg,
  previewFontSize,
} from '../utils/diplomaLayout';
import './DiplomaPreview.css';

const FIELD_KEYS = ['speaker', 'date', 'participant_name', 'diploma_number', 'topic'];

const DiplomaPreview = ({
  template,
  speakerName = '',
  eventDate = '',
  topic = '',
  participantName = '',
  diplomaNumber = 'DIP-PREVIEW',
}) => {
  const canvasRef = useRef(null);
  const [canvasWidth, setCanvasWidth] = useState(0);

  useEffect(() => {
    const node = canvasRef.current;
    if (!node) return undefined;

    const updateWidth = () => {
      setCanvasWidth(node.clientWidth || 0);
    };

    updateWidth();
    const observer = new ResizeObserver(updateWidth);
    observer.observe(node);
    return () => observer.disconnect();
  }, [template?.background_url]);

  if (!template?.background_url) {
    return (
      <div className="dpv-empty">
        Выберите шаблон, чтобы увидеть предпросмотр
      </div>
    );
  }

  const layout = mergeFieldLayout(template.field_layout);
  const fontColor = template.font_color || '#1a1a1a';
  const topicCfg = normalizeTopicCfg(layout.topic);
  const topicEnabled = topicCfg.enabled !== false;
  const topicText = (topic || '').trim();

  const values = {
    speaker: speakerName || 'Спикер',
    date: eventDate || 'Дата',
    participant_name: participantName || 'ФИО участника',
    diploma_number: diplomaNumber || 'DIP-PREVIEW',
    topic: topicText || template.name || 'Тема',
  };

  const fs = (size) => previewFontSize(size, canvasWidth);

  return (
    <div className="dpv-root">
      <div className="dpv-canvas" ref={canvasRef}>
        <img src={template.background_url} alt="" className="dpv-image" draggable={false} />

        {FIELD_KEYS.map((key) => {
          const cfg = key === 'topic' ? topicCfg : (layout[key] || {});
          if (key === 'topic') {
            if (!topicEnabled) return null;
            return (
              <div
                key={key}
                className="dpv-topic"
                style={{
                  left: `${cfg.box_left ?? 10}%`,
                  top: `${cfg.y ?? 78}%`,
                  width: `${Math.max(5, (cfg.box_right ?? 90) - (cfg.box_left ?? 10))}%`,
                  maxHeight: `${Math.max(5, (cfg.box_bottom ?? 96) - (cfg.y ?? 78))}%`,
                  color: fontColor,
                  fontSize: fs(cfg.font_size || 18),
                  textAlign: cfg.align || 'center',
                }}
              >
                {values.topic}
              </div>
            );
          }

          if (cfg.enabled === false) return null;

          const align = cfg.align || 'center';
          const transform =
            align === 'center'
              ? 'translate(-50%, -50%)'
              : align === 'right'
                ? 'translate(-100%, -50%)'
                : 'translate(0, -50%)';

          return (
            <div
              key={key}
              className="dpv-field"
              style={{
                left: `${cfg.x ?? 50}%`,
                top: `${cfg.y ?? 50}%`,
                color: fontColor,
                fontSize: fs(cfg.font_size || 20),
                textAlign: align,
                transform,
              }}
            >
              {values[key]}
            </div>
          );
        })}
      </div>
      <p className="dpv-note">
        Предпросмотр первого участника. Размеры шрифта в PDF совпадают с предпросмотром.
      </p>
    </div>
  );
};

export default DiplomaPreview;
